export { initNav, setMenuToggleFunction };

//* Declare globals
let allNavs;
let toggleFunction;

/**
 * 
 * @param {function} funcName function literal (not string) to be called when toggle is clicked
 * Takes one parameter, the DOM element of the menu
 */
const setMenuToggleFunction = function ( funcName ){
	toggleFunction = funcName;
}

/**
 * 
 * @param {menuElement} menuElement DOM element of activated/deactived menu
 */
const doMenuToggleFunction = function ( menuElement ) {
	toggleFunction.call( this, menuElement );
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} func to wrap
 * @param {Number} wait in ms (`100`)
 */
function debounce( func, wait ) {
	var timeout;

	return function() {
		var that = this;
		var args = arguments;

		clearTimeout( timeout );

		timeout = setTimeout( function() {
			timeout = null;
			func.apply( that, args );
		}, wait );
	};
}

/**
 * Check whether or not a given element is visible.
 *
 * @param  {Element} $object a DOM element to check
 * @return {bool} true if the current element is hidden
 */
const isHidden = function isElementHidden( element ) {
	if ( 'undefined' === typeof element ) {
		return false;
	}

	return ( null === element.offsetParent );
}

/**
 * resets mobile navigation
 */
const reflowNavs = function reflowMobileNavigation() {
	if ( isHidden( allNavs ) ) {
		
		allNavs.forEach( thisNav => {
			thisNav.removeAttribute('style');
			thisNav.classList.remove('active');
		});

		let allToggles = document.querySelectorAll( '.menu-toggle, .sub-menu-toggle' );
		if( allToggles.length > 0 ){
			allToggles.forEach( thisToggle => {
				thisToggle.classList.remove( 'active' );
			});
		}
	}
}

/**
 * 
 * @param {string} tagType DOM tag type to create
 * @param {mixed} classes [string|array] class(es) to apply to new element
 * @param {string} textContent text to insert into new element
 * @returns {Element} DOM element
 */
const newElement = function createDocumentElement( tagType, classes, textContent ){
	let blank = document.createElement( tagType );
	
	if( typeof classes === 'object' ){ // really, an array
		classes.forEach( thisClass => {
			blank.classList.add( thisClass );
		});
	}
	else if( typeof classes == 'string' ){
		blank.classList.add( classes );
	}

	if( typeof textContent == 'string' ){
		blank.appendChild( document.createTextNode( textContent ) );
	}

	return blank;
}

/**
 * 
 * @param {Element} parentElement DOM element to remove attr from
 * @param {string} attr attribute tag to remove from parentElement
 */
const cleanAttributes = function cleanUpAttributes( parentElement, attr ){
	let found = parentElement.querySelectorAll( `[${attr}]` );
	if( found.length > 0 ){
		found.forEach( ele => {
			ele.removeAttribute( attr );
		});
	}
}

/**
 * 
 * @param {Element} parentElement DOM element to remove className from
 * @param {string} className class to remove from parentElement
 */
function cleanClass( parentElement, className ) {
	let found = parentElement.querySelectorAll( `.${className}` );
	if ( found.length > 0 ) {
		found.forEach( ele => {
			ele.classList.remove( className );
		});
	}
}

/**
 * Clones all <nav> Elements into a new <div class="nav-mobile"> Element.
 */
const cloneNav = function cloneDesktopNavigation(){
	// Create new container `nav-mobile` with menu-toggle and sub-container `menus`
	const siteHeader = document.querySelector('.site-header');
	const navDesktop = document.querySelectorAll( 'nav:not(.pagination)' );
	let navMobile = newElement( 'div', 'nav-mobile' );
	let navToggle = newElement( 'div', 'menu-toggle' );
	let tempSpan = newElement( 'span' );
	let menuContainer = newElement( 'div', 'menus' );
	let subMenuToggle = newElement( 'div', 'sub-menu-toggle' );

	// make five spans
	for( let i = 0; i < 5; i++ ){
		navToggle.appendChild( newElement('span', `bar-${i}`) );
	}

	siteHeader.appendChild( navMobile );
	navMobile.appendChild( navToggle );
	// navToggle.appendChild( tempSpan.cloneNode( false ) )
	// navToggle.appendChild( tempSpan.cloneNode( false ) )
	// navToggle.appendChild( tempSpan );
	navMobile.appendChild( menuContainer );
	subMenuToggle.appendChild( tempSpan.cloneNode( false ) );

	navDesktop.forEach( thisNav => {
		let cloneNav = thisNav.cloneNode( true );
		menuContainer.appendChild( cloneNav );

		let subMenus = cloneNav.querySelectorAll('.sub-menu');
		subMenus.forEach( thisSubMenu => {
			thisSubMenu.before( subMenuToggle.cloneNode( true ) );
		});
	});

	cleanAttributes( navMobile, 'id' );
	cleanClass( navMobile, 'right' );
}

/**
 * Adds eventListeners to all menu-toggles to add/remove 'active' class and call toggleFunction
 */
const showHideNav = function showHideNavigation() {
	const menuToggles = document.querySelectorAll( '.menu-toggle, .sub-menu-toggle' );

	if( menuToggles.length > 0 ){
		menuToggles.forEach( thisToggle => {
			thisToggle.addEventListener( 'click', event => {
				let thisMenu = thisToggle.nextElementSibling;
				if( thisMenu.matches('.menus, .sub-menu' ) ){
					thisMenu.classList.toggle( 'active' );
					doMenuToggleFunction( thisMenu );
				}
				thisToggle.classList.toggle( 'active' );
			});
		})
	}
}

/**
 * defines the allNavs global variable
 */
const setNavs = function selectAllNavs(){
	allNavs = document.querySelectorAll( 'nav' );
}

/**
 * Starts the engine.
 */
const initNav = function initializeMobileNavigation(){
	window.addEventListener( 'DOMContentLoaded', event => {
		setNavs();
		cloneNav();
		showHideNav();
	});

	window.addEventListener( 'resize', event => {
		debounce( reflowNavs, 200 );
	});
}